// extracted by css-extract-rspack-plugin
export default {"wrapper":"RelationPickerWithArrow_wrapper__zGQIf","inverse":"RelationPickerWithArrow_inverse__Moug1","picker":"RelationPickerWithArrow_picker__6SvJ2"};